import { createEpicMiddleware } from 'redux-observable'
import Raven from 'utils/raven'
import createRavenMiddleware from 'raven-for-redux'
import { createBrowserHistory } from 'history'
import { reducer, epic, middlewares } from 'store/ducks'
import { initApp } from 'store/ducks/app'
import xhook from 'xhook'
import hooks from 'utils/hooks'
import { configureStore } from '@reduxjs/toolkit'

export const history = createBrowserHistory()

const store = configureStore({
  reducer,
  middleware: [createEpicMiddleware(epic), createRavenMiddleware(Raven), ...middlewares],
  devTools: process.env.NODE_ENV !== 'production',
})

// XHR request middlewares
if (hooks.before) {
  xhook.before((request) => hooks.before(request, store.getState()))
}

if (hooks.after) {
  xhook.after((response) => hooks.after(response, store.getState()))
}

store.dispatch(initApp())

export default store
